import React, { useState, useEffect } from "react";
import "../css/BerMonthsTheme.css";
import WavingGuy from "../../../assets/img/joseMarichan.png";

/** "Ber months" theme — active September & October only */
export const isBerMonth = () => {
  const month = new Date().getMonth() + 1; // 1-12
  return month === 9 || month === 10;
};

const CYCLE_MS = 5000; // pop every 5s
const VISIBLE_MS = 1500; // stay visible for 1.5s

/**
 * Pops the waving-guy photo in from the corner every CYCLE_MS,
 * stays visible for VISIBLE_MS, then hides again.
 */
export const PoppingGuy = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isBerMonth()) return;

    let hideTimeout;

    const showInterval = setInterval(() => {
      setVisible(true);
      hideTimeout = setTimeout(() => setVisible(false), VISIBLE_MS);
    }, CYCLE_MS);

    return () => {
      clearInterval(showInterval);
      clearTimeout(hideTimeout);
    };
  }, []);

  if (!isBerMonth()) return null;

  return (
    <div
      className={`ber-months-pop-container ${visible ? "is-visible" : "is-hidden"}`}
      aria-hidden="true"
    >
      <img src={WavingGuy} alt="" className="ber-months-pop-img" />
    </div>
  );
};

const BerMonthsTheme = ({ children, className = "" }) => {
  if (!isBerMonth()) return children || null;

  return (
    <div className={`ber-months-theme-wrapper ${className}`}>
      <PoppingGuy />
      {children}
    </div>
  );
};

export default BerMonthsTheme;
